import { IconAdult } from '@lmn/lastminute-react-icons/lastminute-icons-solid.js';
import { IconAuto } from '@/app/common/icons/libraryIcons';

import type { JSX } from 'react';

export type MapboxDirectionsProfile = 'mapbox/driving' | 'mapbox/walking' | 'mapbox/cycling';

export type ProfileConfig = {
  id: MapboxDirectionsProfile;
  icon: () => JSX.Element;
};

const bikePath =
  'M20.667 7.333c1.467 0 2.667-1.2 2.667-2.667s-1.2-2.667-2.667-2.667-2.667 1.2-2.667 2.667 1.2 2.667 2.667 2.667zM6.667 16c-3.733 0-6.667 2.933-6.667 6.667s2.933 6.667 6.667 6.667 6.667-2.933 6.667-6.667-2.933-6.667-6.667-6.667zM6.667 27.333c-2.533 0-4.667-2.133-4.667-4.667s2.133-4.667 4.667-4.667 4.667 2.133 4.667 4.667-2.133 4.667-4.667 4.667zM14.4 14l3.2-3.2 1.067 1.067c1.733 1.733 4 2.8 6.8 2.8v-2.667c-2 0-3.6-0.8-4.8-2l-2.533-2.533c-0.667-0.533-1.333-0.8-2.133-0.8s-1.467 0.267-1.867 0.8l-3.733 3.733c-0.533 0.533-0.8 1.2-0.8 1.867 0 0.8 0.267 1.467 0.8 1.867l4.267 3.733v6.667h2.667v-8.267l-2.933-3.067zM25.333 16c-3.733 0-6.667 2.933-6.667 6.667s2.933 6.667 6.667 6.667 6.667-2.933 6.667-6.667-2.933-6.667-6.667-6.667zM25.333 27.333c-2.533 0-4.667-2.133-4.667-4.667s2.133-4.667 4.667-4.667 4.667 2.133 4.667 4.667-2.133 4.667-4.667 4.667z';

export const profiles: { [key: string]: ProfileConfig } = {
  driving: { id: 'mapbox/driving', icon: () => <IconAuto /> },
  walking: { id: 'mapbox/walking', icon: () => <IconAdult /> },
  cycling: {
    id: 'mapbox/cycling',
    icon: () => (
      <svg viewBox="0 0 32 32">
        <path d={bikePath} />
      </svg>
    ),
  },
};
